import '../App.css';
import Cta from '../components/Cta';
import { Link } from 'react-router-dom';
import NetworkGraph from '../components/NetworkGraph';
import Reveal from '../components/Reveal';
import ProjectCard from '../components/ProjectCard';
import portfolioProjects from '../data/Portfolioprojects';

function Portfolio() {
  return (
    <>
      {/* ═══════════════ HERO ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="footer" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <span>Portfólio</span>
          </div>
          <div className="hero__badge animate-up animate-up--d1">
            <span className="hero__badge-dot"></span>
            Portfólio de Projetos
          </div>
          <h1
            className="hero__title animate-up animate-up--d2"
            style={{ maxWidth: '720px' }}
          >
            Sites e sistemas que <em>colocamos no ar</em>
          </h1>
          <p
            className="hero__subtitle animate-up animate-up--d3"
            style={{ maxWidth: '620px', marginBottom: 0 }}
          >
            Além de cuidar da infraestrutura de TI das empresas que atendemos,
            também desenvolvemos sites institucionais, lojas virtuais, sistemas
            de gestão e plataformas sob medida. Aqui estão alguns dos projetos
            que já entregamos.
          </p>
        </div>
      </section>

      {/* ═══════════════ GRID DE PROJETOS ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="section-header">
            <div className="section-header__text">
              <div className="tag">Trabalhos entregues</div>
              <h2 className="section-title">
                Projetos desenvolvidos
                <br />
                <span className="text-blue">pela sepolTECH</span>
              </h2>
              <p className="section-subtitle">
                Cada projeto nasce de uma necessidade real de um cliente — do
                briefing ao lançamento cuidamos do design e do desenvolvimento
                e, quando faz sentido, seguimos responsáveis pela hospedagem e
                pela manutenção contínua depois que o site vai ao ar.
              </p>
            </div>
          </Reveal>

          <div className="grid-3 portfolio-grid" style={{ gap: '24px' }}>
            {portfolioProjects.map((project, i) => (
              <ProjectCard
                key={project.title}
                project={project}
                delay={(i % 3) * 0.08}
              />
            ))}
          </div>
        </div>
      </section>

      <Cta></Cta>
    </>
  );
}

export default Portfolio;
